/*
 * NOURION Buehne "Erwachen von Hamburg".
 * Portierung von src/components/stage/StageHamburg.tsx (React) auf Vanilla JS.
 * Funktionsgleich: Kameraflug (6 Keyframes, smoothstep), gedaempfter
 * Scroll Fortschritt (Lerp 0.09 im rAF), Intro Anflug (1800 ms, bei Scroll
 * auf 500 ms gestaucht), Maus Parallaxe (nur pointer: fine), Tagesphasen
 * Abendrot, Morgen, Tag, goldener Abend, Nacht, Zeichnen der Skyline
 * ueber stroke-dashoffset, prefers-reduced-motion als stehende Szene.
 */
(function () {
  'use strict';

  /* Initialisierung als Funktion: laeuft beim Laden der Seite und erneut
     bei shopify:section:load (Theme Editor rendert die Section ohne
     Seiten Reload neu, das alte JS liefe sonst gegen tote Knoten).
     Vor jedem Neustart raeumt die vorige Instanz ihre Listener ab. */
  function initStage() {
  if (window.__nstCleanup) { window.__nstCleanup(); window.__nstCleanup = null; }

  var root = document.getElementById('nst-root');
  if (!root) return;

  var cleanups = [];
  var killed = false;
  window.__nstCleanup = function () {
    killed = true;
    for (var ci = 0; ci < cleanups.length; ci++) cleanups[ci]();
  };

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Farbwerkzeuge (1:1 aus StageHamburg.tsx) */
  function lerp(a, b, t) { return a + (b - a) * t; }
  function hexToRgb(h) {
    return [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)];
  }
  function mix(h1, h2, t) {
    var a = hexToRgb(h1), b = hexToRgb(h2);
    return 'rgb(' + Math.round(lerp(a[0], b[0], t)) + ',' + Math.round(lerp(a[1], b[1], t)) + ',' + Math.round(lerp(a[2], b[2], t)) + ')';
  }
  /* Zweisegmentige Interpolation ueber einen warmen Mittelton (nie Grau) */
  function mix2(a, m, b, t) {
    return t < 0.5 ? mix(a, m, t * 2) : mix(m, b, (t - 0.5) * 2);
  }
  function clamp01(v) { return Math.min(1, Math.max(0, v)); }
  function seg(p, a, b) { return clamp01((p - a) / (b - a)); }
  function smoothstep(t) { return t * t * (3 - 2 * t); }
  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

  /* Himmel Stuetzpunkte */
  var NIGHT_TOP = '#0C1826', DAWN_TOP = '#7A8598', DAY_TOP = '#F4EDE0';
  var NIGHT_BOT = '#14243A', DAWN_BOT = '#DFAE6C', DAY_BOT = '#FAF6EE';

  /* Tag Fortschritt aus Scroll Fortschritt:
     0 bis 12% Abendrot, 12 bis 36% Morgen, 36 bis 56% Tag,
     56 bis 92% goldener Abend, 92 bis 100% Nacht */
  function dayOf(p) {
    return p < 0.36 ? seg(p, 0.12, 0.36) : p < 0.56 ? 1 : 1 - seg(p, 0.56, 0.92);
  }

  /* Flugkurve der Kamera: [p, camZ, Neigung Grad, camY px] */
  var CAM_PATH = [
    [0.00, -300, 10.5, -46],
    [0.10, -180, 8.0, -30],
    [0.30, 130, 2.5, -6],
    [0.58, 235, 0.0, 0],
    [0.80, 150, 2.0, 6],
    [1.00, -120, 7.0, 16]
  ];
  function camAt(p, damp) {
    var i = 0;
    while (i < CAM_PATH.length - 2 && p > CAM_PATH[i + 1][0]) i++;
    var k0 = CAM_PATH[i], k1 = CAM_PATH[i + 1];
    var t = smoothstep(seg(p, k0[0], k1[0]));
    return {
      z: lerp(k0[1], k1[1], t) * damp,
      tilt: lerp(k0[2], k1[2], t) * damp,
      y: lerp(k0[3], k1[3], t) * damp
    };
  }

  /* Parallax Staerke je Ebene (translateY bei vollem Scrollweg, px) */
  var PAR = { far: -16, back: -34, data: -40, front: -52 };

  /* Intro Anflug: Start weit draussen und hoch */
  var INTRO_CAM = { z: -700, tilt: 12, y: -60 };
  var INTRO_MS = 1800;

  /* Elementgriffe */
  function el(id) { return document.getElementById(id); }
  var sky = el('nst-sky'), glow = el('nst-glow'), cam = el('nst-cam'),
      seal = el('nst-seal'), starsWrap = el('nst-stars'), consts = el('nst-const'),
      haze = el('nst-haze'), farWrap = el('nst-far-wrap'), farG = el('nst-far'),
      backWrap = el('nst-back-wrap'), backG = el('nst-back'),
      frontWrap = el('nst-front-wrap'), frontG = el('nst-front'),
      backWin = el('nst-back-windows'), frontWin = el('nst-front-windows'),
      reflex = el('nst-reflex'), dataWrap = el('nst-data-wrap'), dataG = el('nst-data'),
      gulls = el('nst-gulls'), vignette = el('nst-vignette');

  /* Sterne einmalig wuerfeln (44 Stueck, die ersten 20 auch mobil).
     Vorher leeren: macht die Initialisierung idempotent, falls das
     Skript doppelt laeuft oder die Section neu gerendert wird. */
  if (starsWrap) {
    starsWrap.innerHTML = '';
    var frag = document.createDocumentFragment();
    for (var si = 0; si < 44; si++) {
      var s = document.createElement('span');
      s.className = 'nst-star' + (si < 20 ? '' : ' nst-star--desk');
      s.style.left = (Math.random() * 100) + '%';
      s.style.top = (Math.random() * 46) + '%';
      s.style.animationDelay = (Math.random() * 3.4) + 's';
      frag.appendChild(s);
    }
    starsWrap.appendChild(frag);
  }

  /* Reduzierte Bewegung: SMIL Animationen (Uhrzeiger, Moewenschlag,
     Datenlichter) entfernen, CSS Gates blenden die Traeger ohnehin aus */
  if (reduce) {
    var anims = root.querySelectorAll('animate, animateTransform, animateMotion');
    for (var ai = 0; ai < anims.length; ai++) anims[ai].parentNode.removeChild(anims[ai]);
  }

  /* Flughoehe auf kleinen Screens drosseln */
  var mqSmall = window.matchMedia('(max-width: 767px)');
  var damp = mqSmall.matches ? 0.55 : 1;

  /* Intro Zustand: Auf der Website lebte er im Modul Scope (Unterseite und
     zurueck fliegt nicht erneut, erst ein echter Reload). Shopify laedt jede
     Seite echt neu, deshalb uebernimmt sessionStorage diese Rolle: einmal
     pro Browser Sitzung anfliegen, danach steht die Kamera sofort. */
  var introSchonGeflogen = false;
  try { introSchonGeflogen = sessionStorage.getItem('nst-intro-done') === '1'; } catch (e) { /* Safari privat */ }
  var introK = (reduce || introSchonGeflogen) ? 1 : 0;
  var introT0 = 0;
  var introDur = INTRO_MS;

  /* Maus Parallaxe: gedaempfte Zeigerposition (-1 ... 1) */
  var ptrTX = 0, ptrTY = 0, ptrX = 0, ptrY = 0;

  /* Zeichenpfade vorbereiten (Stadtbaender + ferne Skyline) */
  var drawEls = Array.prototype.slice.call(root.querySelectorAll('.nst-dr'));
  var lens = drawEls.map(function (d) {
    var len = d.getTotalLength();
    d.style.strokeDasharray = String(len);
    d.style.strokeDashoffset = String(len);
    return len;
  });

  function render(pRaw) {
    var p = reduce ? 0 : pRaw;
    var day = dayOf(p);
    var draw = reduce ? 1 : seg(p, 0.04, 0.32);

    if (sky) sky.style.background =
      'linear-gradient(180deg, ' + mix2(NIGHT_TOP, DAWN_TOP, DAY_TOP, day) + ' 0%, ' +
      mix2(NIGHT_BOT, DAWN_BOT, DAY_BOT, day) + ' 100%)';

    /* Goldhorizont: glueht ab Start, lodert in den Uebergaengen, ruht am Tag */
    var dawnPulse = 1 - Math.abs(day - 0.5) * 2;
    var introGlow = introK < 1 ? 1 - easeOutCubic(introK) : 0;
    if (glow) {
      glow.style.opacity = String((0.55 + dawnPulse * 0.45 - day * 0.3) * (1 + 0.7 * introGlow));
      glow.style.height = ((48 + dawnPulse * 22) * (1 + 0.55 * introGlow)) + '%';
    }

    /* Anflug: Sterne, Konstellationen und Siegel zuenden mit der Landung */
    var twinkle = introK < 1 ? 0.35 + 0.65 * easeOutCubic(introK) : 1;

    if (starsWrap) starsWrap.style.opacity = String((1 - day) * twinkle);
    if (consts) consts.style.opacity = String((1 - day) * 0.9 * twinkle);
    if (backWin) backWin.style.opacity = String(0.25 + (1 - day) * 0.75);
    if (frontWin) frontWin.style.opacity = String(0.25 + (1 - day) * 0.75);
    if (reflex) reflex.style.opacity = String((1 - day) * 0.85);
    if (dataG) dataG.style.opacity = String(0.35 + (1 - day) * 0.65);

    /* Moewen gehoeren dem Tag */
    if (gulls) gulls.style.opacity = String(day * 0.75);

    /* Kiona N Siegel: nur nachts, hauchzart */
    if (seal) seal.style.opacity = String(0.06 * (1 - day) * twinkle + 0.05 * introGlow);

    /* Dunst am Horizont */
    if (haze) {
      haze.style.opacity = String(0.12 + dawnPulse * 0.22);
      haze.style.background =
        'linear-gradient(180deg, transparent 0%, ' + mix2('#14243A', '#DFAE6C', '#F4EDDF', day) + ' 78%, transparent 100%)';
    }

    for (var i = 0; i < drawEls.length; i++) {
      drawEls[i].style.strokeDashoffset = String(lens[i] * (1 - draw));
    }

    /* Linienfarbe: nachts Eisblau, tags Hafen Navy (fern heller) */
    var inkNear = mix('#7FB4C4', '#3D5A70', day);
    if (backG) backG.setAttribute('stroke', inkNear);
    if (frontG) frontG.setAttribute('stroke', inkNear);
    if (farG) farG.setAttribute('stroke', mix('#7FB4C4', '#5E7891', day));

    /* Der Kameraflug, beim Anflug von INTRO_CAM zur Scroll Kamera geblendet */
    var c = reduce ? { z: 0, tilt: 0, y: 0 } : camAt(p, damp);
    if (introK < 1) {
      var k = easeOutCubic(introK);
      c = {
        z: lerp(INTRO_CAM.z * damp, c.z, k),
        tilt: lerp(INTRO_CAM.tilt * damp, c.tilt, k),
        y: lerp(INTRO_CAM.y * damp, c.y, k)
      };
    }
    /* Maus Parallaxe: die ganze Stadt kippt minimal mit dem Cursor */
    var rotY = ptrX * 3.4;
    var rotXp = -ptrY * 1.8;
    if (cam) cam.style.transform =
      'translateZ(' + c.z + 'px) rotateX(' + (c.tilt + rotXp) + 'deg) rotateY(' + rotY + 'deg) translateY(' + c.y + 'px)';

    /* Vignette vertieft die Nacht */
    if (vignette) vignette.style.opacity = String(0.1 + (1 - day) * 0.24);

    /* Parallaxe je Ebene (zusaetzlich zum Dolly) */
    if (farWrap) farWrap.style.setProperty('--par', (p * PAR.far) + 'px');
    if (backWrap) backWrap.style.setProperty('--par', (p * PAR.back) + 'px');
    if (dataWrap) dataWrap.style.setProperty('--par', (p * PAR.data) + 'px');
    if (frontWrap) frontWrap.style.setProperty('--par', (p * PAR.front) + 'px');
  }

  /* Scroll Fortschritt der ganzen Seite (Ersatz fuer useScroll) */
  function progress() {
    var docH = document.documentElement.scrollHeight - window.innerHeight;
    if (docH <= 0) return 0;
    return clamp01((window.scrollY || window.pageYOffset || 0) / docH);
  }

  /* Reduzierte Bewegung: stehende Szene, keine Loops */
  if (reduce) {
    render(0);
    return;
  }

  /* Gedaempfter Fortschritt: die Buehne folgt dem Scrollen weich nach */
  var smooth = progress();
  var target = smooth;
  var running = false;
  function tick() {
    if (killed) { running = false; return; }
    var d = target - smooth;
    if (Math.abs(d) < 0.0004) {
      smooth = target;
      render(smooth);
      running = false;
      return;
    }
    smooth += d * 0.09;
    render(smooth);
    requestAnimationFrame(tick);
  }
  function kick() {
    if (!running) {
      running = true;
      requestAnimationFrame(tick);
    }
  }

  render(smooth);

  /* Intro Anflug: einmal pro Seitenaufruf, zeitgesteuert neben dem Smoothing */
  if (introK < 1) {
    introT0 = performance.now();
    (function introTick() {
      if (killed) return;
      introK = Math.min(1, (performance.now() - introT0) / introDur);
      render(smooth);
      if (introK < 1) { requestAnimationFrame(introTick); return; }
      try { sessionStorage.setItem('nst-intro-done', '1'); } catch (e) { /* Safari privat */ }
    })();
  }

  function onScroll() {
    target = progress();
    /* Scrollt der Besucher in den Anflug hinein: Restflug auf 500 ms stauchen */
    if (introK < 1 && introDur > 500) {
      introDur = 500;
      introT0 = performance.now() - introK * introDur;
    }
    kick();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  cleanups.push(function () { window.removeEventListener('scroll', onScroll); });

  /* Seitenhoehe aendert sich (Bilder, Akkordeons): Fortschritt nachziehen */
  function onResize() {
    target = progress();
    kick();
  }
  window.addEventListener('resize', onResize);
  cleanups.push(function () { window.removeEventListener('resize', onResize); });
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(function () {
      target = progress();
      kick();
    });
    ro.observe(document.documentElement);
    cleanups.push(function () { ro.disconnect(); });
  }

  /* Maus Parallaxe (nur mit echtem Zeiger): eigener Daempfungs Loop */
  var ptrRunning = false;
  function ptrTick() {
    if (killed) { ptrRunning = false; return; }
    var dx = ptrTX - ptrX, dy = ptrTY - ptrY;
    if (Math.abs(dx) < 0.001 && Math.abs(dy) < 0.001) {
      ptrX = ptrTX; ptrY = ptrTY; render(smooth); ptrRunning = false; return;
    }
    ptrX += dx * 0.07; ptrY += dy * 0.07;
    render(smooth);
    requestAnimationFrame(ptrTick);
  }
  function onPointer(e) {
    ptrTX = (e.clientX / window.innerWidth - 0.5) * 2;
    ptrTY = (e.clientY / window.innerHeight - 0.5) * 2;
    if (!ptrRunning) { ptrRunning = true; requestAnimationFrame(ptrTick); }
  }
  if (window.matchMedia('(pointer: fine)').matches) {
    window.addEventListener('pointermove', onPointer, { passive: true });
    cleanups.push(function () { window.removeEventListener('pointermove', onPointer); });
  }

  /* Geraetedrehung: Daempfung sofort nachziehen und neu zeichnen */
  function onMqSmall() {
    damp = mqSmall.matches ? 0.55 : 1;
    render(smooth);
  }
  mqSmall.addEventListener('change', onMqSmall);
  cleanups.push(function () { mqSmall.removeEventListener('change', onMqSmall); });
  }

  initStage();

  /* Theme Editor: Section wird ohne Seiten Reload neu gerendert */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#nst-root')) initStage();
  });
})();
